import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "formulario-modelo" }
const _hoisted_2 = { class: "superior" }
const _hoisted_3 = {
  key: 0,
  class: "botones"
}

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import ListaModelos from '../components/ListaModelos.vue'
import useAutenticar from '@/store/IngresoAutenticar'


export default /*@__PURE__*/_defineComponent({
  __name: 'VersionesView',
  setup(__props) {

/**
 * Versiones de un modelo y carga de evidencias.
 *
 * Versionar copia los INDICADORES, no la estructura: el árbol pertenece al
 * modelo y lo comparten todas sus versiones.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/evidencias` (SubirEvidencias) — permiso `evidencias.subir`
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const route = useRoute()
const store = useAutenticar()

const modoIndicadores = computed(() => route.query.modo === 'indicadores')
const modoCalificar = computed(() => route.query.modo === 'calificar instrumento')
const modoAsignarEvaluadores = computed(() => route.query.modo === 'asignar-evaluadores')
const modoEvaluacionExpertos = computed(() => route.query.modo === 'evaluacion-expertos')
const modoEvidencias = computed(() => route.query.modo === 'evidencias' || route.name === 'SubirEvidencias')

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      (!modoIndicadores.value && !modoCalificar.value && !modoEvidencias.value && _unref(store).tienePermiso('modelos.crear'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_router_link, { to: { name: 'CrearModelo' } }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("button", { class: "btn guardar" }, "Crear Nuevo Modelo", -1)
              ])),
              _: 1,
              __: [0]
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ListaModelos, {
      "modo-indicadores": modoIndicadores.value,
      "modo-calificar": modoCalificar.value,
      "modo-asignar-evaluadores": modoAsignarEvaluadores.value,
      "modo-evaluacion-expertos": modoEvaluacionExpertos.value,
      "modo-evidencias": modoEvidencias.value
    }, null, 8, ["modo-indicadores", "modo-calificar", "modo-asignar-evaluadores", "modo-evaluacion-expertos", "modo-evidencias"])
  ]))
}
}

})